import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SelectEvent } from "@progress/kendo-angular-upload";
import { CommonService } from "app/reusable/common.service";
import { LocationType } from "app/_models/location-type.model";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-add-location-types",
  templateUrl: "./add-location-types.component.html",
  styleUrls: ["./add-location-types.component.scss"],
})
export class AddLocationTypesComponent implements OnInit, OnDestroy {
  @Input() LocationNames;
  @Input() item: LocationType = new LocationType();
  @Output() Change: EventEmitter<any> = new EventEmitter();
  AddDialogOpened = false;
  public LocationTypeForm: FormGroup;
  public LocationType = new LocationType();
  imgUrl: string = "/assets/img/avatars/icon-preview.png";
  IconToUpload = null;
  IsSelected = false;
  IsOnMap = false;
  public LocationTypeExists: boolean = false;
  send = [];

  private _subject$: Subject<boolean> = new Subject();

  constructor(private CommonService: CommonService) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.LocationTypeForm = new FormGroup({
      lctName: new FormControl(this.item.lctName, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      lctIcon: new FormControl(this.item.lctIcon),
      lctIsSelected: new FormControl(this.item.lctIsSelected),
    });
  }
  public hasError = (controlName: string, errorName: string) => {
    return this.LocationTypeForm.controls[controlName].hasError(errorName);
  };

  public CreateLocationType = (LocationTypeFormValue) => {
    if (this.LocationTypeForm.valid) {
      if (this.LocationNames.includes(LocationTypeFormValue.lctName) == false) {
        this.ExecuteLocationTypeCreation(LocationTypeFormValue);
      } else {
        this.LocationTypeExists = true;
      }
    }
  };

  private ExecuteLocationTypeCreation = (LocationTypeFormValue) => {
    this.LocationType.lctName = LocationTypeFormValue.lctName;
    this.LocationType.lctIcon = LocationTypeFormValue.lctIcon;
    this.LocationType.lctIsSelected = LocationTypeFormValue.lctIsSelected;
    let PostLocationTypeUrl: string = `Location/Post`;
    let locationPost = {
      lctName: this.LocationType.lctName,
      lctIcon: this.LocationType.lctIcon,
      lctId: this.item.lctId,
      lctIsSelected: this.LocationType.lctIsSelected,
    };

    if (this.item.lctId == null) {
      this.CommonService.create(PostLocationTypeUrl, locationPost).pipe(takeUntil(this._subject$)).subscribe(
        (res) => {
          this.Change.emit({ add: true, location: res });
        }
      );
    } else {
      this.CommonService.update("Location/Update", locationPost).pipe(takeUntil(this._subject$)).subscribe(
        (res) => {
          let location: any = res;
          this.Change.emit({ add: false, location: location });
        }
      );
    }
  };

  public Cancel() {
    this.Change.emit(false);
  }


  resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
    return new Promise((resolve) => {
      let img = new Image()
      img.src = base64Str
      img.onload = () => {
        let canvas = document.createElement('canvas')
        const MAX_WIDTH = maxWidth
        const MAX_HEIGHT = maxHeight
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL())
      }
    })
  }

  public selectIconHandler(e: SelectEvent): void {
    const that = this;
    const file = e.files[0];
    if (!file.validationErrors) {
      const reader = new FileReader();
      reader.onload = function () {
        that.resizeImage(reader.result, 72, 72).then((result) => {
          that.LocationTypeForm.controls['lctIcon'].patchValue(result);
        });

      };
      reader.readAsDataURL(file.rawFile);
    }
  }


  public removeIconHandler(e): void{
    this.LocationTypeForm.controls['lctIcon'].patchValue(null)
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();

  }
}
